export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/topojson/~/topojson-client/src/identity.js
// module id = 443
// module chunks = 0